import { render, staticRenderFns } from "./ScreensaverUpsellForm.vue?vue&type=template&id=06f10318"
import script from "./ScreensaverUpsellForm.vue?vue&type=script&lang=ts"
export * from "./ScreensaverUpsellForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports